// extracted by mini-css-extract-plugin
export default {"favBtn":"FavButton_favBtn__bgk4a"};